import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import Navigation from '../../components/Navigation';

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const hash = window.location.hash;
    const isRecovery = hash.includes('type=recovery');

    let timeoutId;

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        console.log('AuthCallback event:', event, 'session:', !!session);

        if (event === 'SIGNED_IN' && session) {
          clearTimeout(timeoutId);
          window.history.replaceState({}, document.title, window.location.pathname);
          navigate(isRecovery ? '/reset-password' : '/my-profile', { replace: true });
        }

        if (event === 'PASSWORD_RECOVERY') {
          clearTimeout(timeoutId);
          window.history.replaceState({}, document.title, window.location.pathname);
          navigate('/reset-password', { replace: true });
        }
      }
    );

    // Also check if already has a session (e.g. hash already processed)
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        navigate(isRecovery ? '/reset-password' : '/my-profile', { replace: true });
      }
    });

    // Timeout after 10 seconds
    timeoutId = setTimeout(() => {
      setError('Authentication timed out. Please try again.');
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    }, 10000);

    return () => {
      clearTimeout(timeoutId);
      subscription?.unsubscribe();
    };
  }, [navigate]);

  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pt-24 flex items-center justify-center">
        <div className="text-center">
          {error ? (
            <>
              <p className="text-red-600 mb-4">{error}</p>
              <p className="text-gray-500 text-sm">Redirecting to login...</p>
            </>
          ) : (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
              <p className="text-gray-600 dark:text-gray-400">Processing authentication...</p>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AuthCallbackPage;
